import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { CityService } from 'src/app/services/http/business/city/city.service';
import { MajorDegreeService } from 'src/app/services/http/business/majorDegree/major-degree.service';
import { JobService } from 'src/app/services/http/business/job/job.service';
import { ProvinceService } from 'src/app/services/http/business/province/provinces.service';
import { IProvince } from 'src/app/interfaces/province';
import { ICity } from 'src/app/interfaces/city';
import { IMajorDegree } from 'src/app/interfaces/majorDegree';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrls: ['./profile-edit.component.css']
})
export class ProfileEditComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  isOwner: boolean;
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();
  maxDate: Date;


  provinceList: IProvince;
  cityList: ICity;
  jobList: any;
  majorList: IMajorDegree[];
  degreeList: IMajorDegree;


  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private cityService: CityService,
    private majorService: MajorDegreeService,
    private jobService: JobService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public dialogRef: MatDialogRef<ProfileEditComponent>,
    private accountService: AccountService,
    private provinceService: ProvinceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.getUserInfo();
    this.getMajor();
    this.getjob();
    this.loadProvience();
  }

  getUserInfo() {
    this.accountService.getUserInfoByNationalCode(this.data.NationalCode).subscribe(res => {
      this.createForm(res);
    });
  }



  createForm(data) {
    this.form = this.fb.group(
      {
        PersonEncryptId: [data.PersonEncryptId],
        FirstName: [
          data && data.FirstName ? data.FirstName.toString() : null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        LastName: [
          data && data.LastName ? data.LastName.toString() : null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        FatherName: [
          data && data.FatherName ? data.FatherName.toString() : null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("[\u0600-\u06FF 0-9-]+")
          ])
        ],
        PhoneNumber: [
          data && data.CellPhoneNumber ? data.CellPhoneNumber.toString() : null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(11),
            Validators.pattern("^(09[0-9][0-9]{8})?$")
          ])
        ],
        HomePhone: [
          data && data.HomePhone ? data.HomePhone.toString() : null,
          Validators.compose([
            Validators.maxLength(15),
            Validators.pattern("^[0-9]*$")
          ])
        ],
        Address: [
          data && data.Address ? data.Address.toString() : null,
          Validators.compose([
            Validators.maxLength(300)
          ])
        ],
        BirthDate: [
          data && data.BirthDate ? data.BirthDate.toString() : null,
          Validators.compose([
            Validators.maxLength(300)
          ])
        ],
        Email: [
          data && data.Email ? data.Email.toString() : null,
          Validators.compose([
            Validators.pattern(
              "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+.[a-zA-Z]{2,5}(.[a-zA-Z]{2,5}){0,1}"
            )
          ])
        ],
        Gender: [data.Gender, Validators.compose([Validators.required])],
        DegreeId: [data && data.DegreeId ? data.DegreeId.toString() : null],
        MajorId: [data && data.MajorId ? data.MajorId.toString() : null],
        JobId: [data && data.JobId ? data.JobId.toString() : null],
        ProvinceId: [data && data.ProvinceId ? data.ProvinceId.toString() : null],
        PlaceCityId: [data && data.PlaceCityId ? data.PlaceCityId.toString() : null]
      }
    );
    if (data.DegreeId)
      this.majorService.degreeList(data.DegreeId).subscribe(
        res => {
          this.majorList = res.EduMajors;
        },
        () => {
          this.errorService.transactionError();
        }
      );

    if (data.ProvinceId)
      this.cityService.GetList(data.ProvinceId).subscribe(res => {
        this.cityList = res;
      });
  }

  submit(form: any) {
    if (form.BirthDate)
      form.BirthDate = moment
        .from(form.BirthDate, "en")
        .utc(true)
        .format(environment.dateFormat);
    this.errors = new Array();
    this.accountService.updateUserProfile(form).subscribe(() => {
      this.snackBar.OpenSnackBar(
        'اطلاعات پروفایل شما با موفقیت ویرایش شد.',
        "ok",
        3000,
        SoundEnum.beep
      );
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );

  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }


  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(res => {
      this.cityList = res;
    });
  }

  getMajor() {
    this.majorService.list().subscribe(
      res => {
        this.degreeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getjob() {
    this.jobService.list().subscribe(res => {
      this.jobList = res.DataList;
    })
  }

  loadMajor(element: MatSelect) {
    this.majorService.degreeList(element.value).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

}
